export default __webpack_public_path__ + "static/media/icon-user-negative.a4c64ddf.svg";